import { ConstActions } from './../../consts/positionActions.const';
import { Component, OnInit, Input, AfterViewInit, ViewChild, ViewEncapsulation, OnDestroy, Output, EventEmitter, 
          SimpleChanges, OnChanges, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { DatatableService } from './datatable.service';
import { Page } from './datatable.page.interface';
import { environment } from 'environments/environment';
import { MatSnackBar, MatDialogRef } from '@angular/material';
import { MatDialog } from '@angular/material';
import { DescriptionPopupComponent } from './description-popup/description-popup.component';
import { HelpersService } from '../../services/helpers/helpers.service';
import { PrivateFilterComponent } from './private-filter/private-filter.component';
import { InputDialogComponent } from '../input-dialog/input-dialog.component';
import { WsAppsSettingsComponent } from '../../apps/ws-apps-settings/ws-apps-settings.component';
import { fuseAnimations } from '@fuse/animations';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import * as _ from 'lodash';
import { OfficeHelpersService } from '../../services/office-helpers/office-helpers.service';
import { IOfficeData } from '../../interfaces/office.interface';
import { RecordBulkUpdateComponent } from './record-bulk-update/record-bulk-update.component';

declare var $: any;

@Component({
  selector: 'app-datatable',
  templateUrl: './datatable.component.html',
  styleUrls: ['./datatable.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations
})
export class DatatableComponent
  implements OnInit, AfterViewInit, OnDestroy, OnChanges {
  @Input() regId;

  loadingIndicator = true;
  confirmDialogRef: MatDialogRef<InputDialogComponent>;
  public mask = [/[0-2]/, /[0-3]/, ':', /[0-5]/, /\d/];

  allData: any = {};
  requestData: any = {};
  timeFilter: any = {
    startTime: '00:00',
    endTime: '23:59'
  };
  dateTimeFilterType = 'customValue';
  valueFilter: any = {};
  officeFilters = [];
  selectedOfficeFilter = '';

  dateTimeFormatMapping = {
      'y': 'years',
      'Q': 'quarters',
      'M': 'months',
      'w': 'weeks',
      'd': 'days',
      'h': 'hours',
      'm': 'minutes',
      's': 'seconds'
  };

  lastSearchPersisted = false;
  init = true;
  @ViewChild('privateFilter')
  public privateFilter: PrivateFilterComponent;
  @Input() options;
  @Input() isAdmin;
  @Input() hardFilter;
  @Input() fieldData;
  @Input() appData: any;
  @Input() wsInfo;
  @Input() calculateOnSave: boolean;
  @Output() updateOnSave: EventEmitter<any> = new EventEmitter();
  fastQuery = '';
  selected = [];
  loading = false;
  dataTablePastRequestData: any;
  fastSearchField;
  public preview;
  public enableMoreActionIcon = false;
  public currentLang: string;
  public translationDatatable: object;
  public filters: object = {};
  public dataRanageKey: string;
  public columns: any = [];
  public page = new Page();
  public rows;
  public dataTablesParameters: object = {};

  defaultHardFilter;
  wsRequiredFieldDone = true;
  officeId: string;
  errorMessage = '';
  mqHardFilterString = '';
  currentMQFilter = '';
  open = false;
  inlineEditCols = [];
  inlineEditCell = {};
  cardVars = {};
  cardVarsArray = [];
  dtTableAdvanceFilters = [];
  chartData = [];
  rowCalculations = {};
  colCalculations = {};
  summaryArray = [];
  searchText = '';
  processFilters = {};
  showTotalRow = false;
  filterOption: any;
  fastQuery2: any;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private translationLoader: FuseTranslationLoaderService,
    private translate: TranslateService,
    public datatableService: DatatableService,
    public snackBar: MatSnackBar,
    public dialog: MatDialog,
    private helperService: HelpersService,
    private _changeDetectorRef: ChangeDetectorRef,
    private _officeHelper: OfficeHelpersService

  ) {

    this.route.queryParams.subscribe((params) => {
    });

    this.initDateFilter();

    // translations
    this.helperService
      .getTrans('datatable')
      .then(data2 => {
        this.translationLoader.loadTranslationsV2(data2);
      })
      .catch(err => {
        console.log(err);
      });

    this.currentLang = this.translate.currentLang || 'en';

    this.translate.onLangChange.subscribe(
      (event: LangChangeEvent) => {
        this.currentLang = event['lang'] || this.translate.currentLang;
      },
      err => {
        console.log(err);
      }
    );
  }

  ngOnChanges(changes: any) {

    this.fastQuery = '';
    this.summaryArray = [];
    this.requestData = {};
    // this.appData = {};
    if ((changes.regId && !changes.regId.firstChange) || (changes.appData && !changes.appData.firstChange)) {
      this.rows = null;
      this.init = true;
      this.requestData = {};
      this.getOfficeFiltersForRegister();
      this.resetFilterValues();
      this.setFromLocalData();
      this.getServerSideRecord();
      this.initDateFilter();
    }
    this.dateTimeFilterType = (this.appData && this.appData.defaultDateFilter) || '##df_all##';
    this.valueFilter = {
      'registredDataTime': this.getDateFromDateSearchControlerType()
    };
  }

  ngOnInit(): void {
    this.processFilters = {};
    this.setFromLocalData();
    this.getServerSideRecord();
    this.checkWSRequiredField();
    this.getOfficeFiltersForRegister();
    this.initDateFilter();

    this.datatableService.onPositionRecordChange.subscribe((isChanged: boolean) => {
      if (this.datatableService.applicationType === 'position' && isChanged) {
        this.updateParentRecord();
      }
    });

    this.datatableService.reRenderData.subscribe((reRender: boolean) => {
      if (reRender && this.regId) {
        this.rows = null;
        this.checkWSRequiredField();
        this.getServerSideRecord();
      }
    });
        
      this.datatableService.onFilterChanged.subscribe((filters) => {
        if (filters && Object.keys(filters).length) {
          this.checkWSRequiredField();
          this.requestData['filters'] = filters || {};
          if (this.allData && Object.keys(this.allData).length) {
            this.getServerSideRecord();
          }
        }
      },
      err => {
        this.filters = this.filters || {};
        console.log(err);
        this.snackBar.open(
          err || 'Error occured while getting data',
          'Okay',
          {
            duration: 2000
          }
        );
      }
    );

    this.page.size = (this.allData && this.allData['length']) || 15;

    this.resetValues();

    this.formChartAndInlineEditVariable();
  }

  setFromLocalData() {
    if (this.datatableService.applicationType !== 'position') {
      const tt = (localStorage.getItem('wsAppData') && JSON.parse(localStorage.getItem('wsAppData'))) || {};
      const appSlug = tt['appUrlSlug'] || tt['appSlug'];
      const temp = (localStorage.getItem(appSlug) && JSON.parse(localStorage.getItem(appSlug))) || {};
      this.dataTablePastRequestData = temp;
      if (temp && Object.keys(temp).length) {
        this.lastSearchPersisted = true;
        this.reopenFilters();
      } else {
        this.lastSearchPersisted = false;
      }
      if (temp && temp.requestData && Object.keys(temp.requestData)) {
        this.requestData = temp.requestData || {};
        this.requestData.filters = this.requestData.filters || {};
        this.dateTimeFilterType = (this.appData && this.appData.defaultDateFilter) || '##df_all##';
        this.requestData.filters = Object.assign(this.requestData.filters, {
          'registredDataTime': this.getDateFromDateSearchControlerType()
        });
        this.valueFilter = this.requestData.filters;
      }
    }
  }

  getDateFromDateSearchControlerType() {
    if (this.appData && this.appData.defaultDateFilter === 'customValue') {
      return this.getFormatedDate(this.timeFilter.startDate, this.timeFilter.endDate);
    } else {
      return '##df_all##';
    }
  }
  
  setLocalData() {
    if (this.datatableService.applicationType !== 'position') {
      const tt = JSON.parse(localStorage.getItem('wsAppData')) || {};
      const temp = {
        requestData: this.requestData,
        openedFilters: {
          advanceFilter: (this.allData && this.allData.filters && this.allData.filters.noAdvanceFiltersSelected),
          dateRangeFilter: (this.allData && this.allData.filters && this.allData.filters.hideDateRange),
          superFilter: (this.allData && this.allData.showSuperFilter)
        }
      };

      const appSlug = tt['appUrlSlug'] || tt['appSlug'];
      localStorage.setItem(appSlug, JSON.stringify(temp));    
    }
  }

  resetLocalData() {
    if (this.datatableService.applicationType !== 'position') {
      const tt = JSON.parse(localStorage.getItem('wsAppData')) || {};
      const temp = {
        requestData: {},
        openedFilters: {
          advanceFilter: (this.allData && this.allData.filters && this.allData.filters.noAdvanceFiltersSelected),
          dateRangeFilter: (this.allData && this.allData.filters && this.allData.filters.hideDateRange),
          superFilter: (this.allData && this.allData.showSuperFilter)
        }
      };

      const appSlug = tt['appUrlSlug'] || tt['appSlug'];
      localStorage.setItem(appSlug, JSON.stringify(temp));    
    }
  }

  ngOnDestroy()
  {
    const tt = JSON.parse(localStorage.getItem('wsAppData')) || {};
    delete tt['statusId'];
    delete tt['instanceId'];
    localStorage.setItem('wsAppData', JSON.stringify(tt));

    this.resetValues();
    this.rows = [];
    this.datatableService.instanceFilters = {};
    this.datatableService.onOptionChange['observers'] = [];
    this.datatableService.reRenderData['observers'] = [];
    this.datatableService.onFilterChanged['observers'] = [];
    this.datatableService.onPositionRecordChange['observers'] = [];
  }

  checkWSRequiredField() {
    this.wsRequiredFieldDone = true;
    if (
      this.appData &&
      this.appData.requiredDataFields &&
      this.appData.requiredDataFields.length
    ) {
      this.appData.requiredDataFields =
        this.appData.requiredDataFields || [];
      this.appData.requiredDataFields.forEach(ele => {
        if (ele.value === null || ele.value === undefined) {
          this.wsRequiredFieldDone = false;
        }
      });
    }
  }

  reInitColumnTotal() {
    if (this.allData && this.allData['columns']) {
      this.allData['columns'].forEach(element => {
        if (element && element['control_type'] && element['control_type']['allTotal']  && element['control_type']['control_type'] !== 'calculation_on_save') {
          this.colCalculations[element['control_type']['label']] = 0;
          this.showTotalRow = true;
        }
      });
    }
  }

  onSort(event) {
    this.requestData['sort'] = (event.sorts && event.sorts[0]) || { dir: 'desc', prop: '_id' };
    this.allData['sort'] = event.sorts;
    this.getServerSideRecord();
  }

  setPage(pageInfo) {
    this.page.pageNumber = pageInfo.offset;
    this.loadingIndicator = true;
    this.getServerSideRecord();
  }

  getFilteredActions(actions, type) {
    actions = actions || [];
    actions = actions.filter(
      (action: any) =>
        action &&
        action.module &&
        (action.module === 'customRegisterRecordsList' ||
          action.module === 'addressbook')
    );
    actions = actions.filter(
      (action: any) =>
        action && action.placement && action.placement[type]
    );
    if (type === 'dropdownActions' && actions.length) {
      this.enableMoreActionIcon = true;
    }
    return actions;
  }

  getServerSideRecord(filters?, mqFilter?) {
    this.allData = this.allData || {};

    this.requestData = this.requestData || {};

    if (
      this.datatableService.params &&
      this.datatableService.params['postionsLookupSettings']
    ) {
      this.requestData['positionFilters'] =
        this.datatableService.params['postionsLookupSettings'] || {};
    }
    
    if (!this.init) {
      this.requestData['page'] = this.page;
    }

    this.requestData['mqFilter'] = '';
    if (this.requestData['currentMQFilter'] && this.appData && this.appData['hardFilter']) {
      this.requestData['mqFilter'] = `${this.appData['hardFilter']} AND ${this.requestData['currentMQFilter']}`;
      // delete this.requestData['currentMQFilter'];
    } else if (this.requestData['currentMQFilter']) {
      this.requestData['mqFilter'] = this.requestData['currentMQFilter'];
      // delete this.requestData['currentMQFilter'];
    } else if (this.appData && this.appData['hardFilter']) {
      this.requestData['mqFilter'] = this.appData['hardFilter'];
    }

    if (mqFilter) {
      if (this.requestData['mqFilter']) {
        this.requestData['mqFilter'] = `${this.requestData['mqFilter']} AND ${mqFilter}`;
      } else {
        this.requestData['mqFilter'] = mqFilter;
      }
    }

    this.requestData['search'] = {
      value: this.fastQuery || '',
      regex: false
    };

    if (this.datatableService && this.datatableService.applicationType === 'workspace') {
      this.appData = this.appData || this.datatableService.appData || {};
      const wsData = (localStorage.getItem('wsAppData') && JSON.parse(localStorage.getItem('wsAppData'))) || {};

      this.requestData['workspace'] = {
        index: wsData.indexNumber || wsData.stepNumber || 0
      };
    }

    this.getFilters();

    if (this.regId) {
      this.setLocalData();
      this.loadingIndicator = true;
      this.helperService.postRequest(`api/registries/${this.regId}/record-list/dttable/v2`, this.requestData)
      .then((data) => {
        this.loadingIndicator = false;
        let tt = (data['dttable'] && data['dttable']['data']) || [];

        this.rowCalculations = data['rowCalculations'] || [];
        this.datatableService.integratedProcessId = data['integratedProcessId'];
        this.datatableService.formId = data['formId'];
        this.page = (data['dttable'] && data['dttable']['page']) || [];

        this.defaultHardFilter = null;

        if (this.init) {
          this.datatableService.allData = data || {};
          // this.requestData['currentMQFilter'] = data['currentMQFilter'] || '';
          this.init = false;

          
          if (this.datatableService.applicationType === 'position') {
            console.log(this.datatableService.params);
            data['actions'] = JSON.parse(JSON.stringify(ConstActions));
            // hideDeleteButton
            if (this.fieldData && !this.fieldData.showDeleteButton) {
              // delete 
              data['actions'].splice(2, 1);
              // if price list reg selected.
              if (!(this.fieldData && this.fieldData.postionsLookupSettings && this.fieldData.postionsLookupSettings.price_list_regId)) {
                data['actions'].splice(2, 1);
              }
            } else {              
              // if price list reg selected.
              if (!(this.fieldData && this.fieldData.postionsLookupSettings && this.fieldData.postionsLookupSettings.price_list_regId)) {
                data['actions'].splice(3, 1);
              }
            }
          }

          if (this.datatableService.applicationType === 'selection') {
            data['actions'].push({
              type: 'function',
              handler: (id) => {
                  // this.http.put()
                  console.log(id);
              },
              translations: {
              pl: 'dttable.select',
              en: 'dttable.select'
              },
              default_label: 'dttable.select',
              placement: {
                  recordActions: true
              },
              module: 'customRegisterRecordsList'
            });
            data['actions'].push({
                'default_label': 'dttable.back',
                'translations': {
                  'pl': 'dttable.back',
                  'en': 'dttable.back'
                },
                'icon': '',
                'sort': '',
                'fuse2App': './../',
                'placement': {
                  'headerActions': true,
                  'subheaderActions': false,
                  'recordActions': false,
                  'dropdownActions': false
                },
                'module': 'customRegisterRecordsList',
                'application': 'app.customregistries.back',
                'params': {},
                'applicationName': 'Go Back',
                'access_level': '2',
                'actionParams': ''
              });
          }
          
          // now format the data...
          data['actions'] = this.datatableService.formatActions(data['actions'], data);
          this.allData = data;
          if (this.allData.filters && this.allData.filters.values && this.allData.filters.values[0]) {
            this.fastSearchField = this.allData.filters.values[0].label;
          }
          // fastSearchField
          this.allData['columns'] = (data && data['columns']) || [];
          if (this.appData && this.appData.subActionList && this.appData.subActionList.length) {
            this.allData['columns'].push({
              'prop': 'subAction',
              'name': 'subAction'
            });
          }
          // this.allData['columns'] = this.allData['columns'].map((ele) => {
          //   // ele['summaryFunc'] = this.getColumnSummary;
          //   ele['summaryFunc'] = (cell) => '***';
          //   return ele;
          // });
          this.allData['columnMode'] = 'flex';
          this.allData['headerHeight'] = 50;
          this.allData['footerHeight'] = 50;
          this.allData['rowHeight'] = 'auto';
          this.allData['externalPaging'] = true;
          this.defaultHardFilter = data['defaultFilter'] || null;

          if (this.datatableService && this.datatableService.applicationType !== 'workspace') {
            this.allData['columns'].push({
              prop: '_id',
              name: 'Actions',
              class: 'action-txt-align',
              sortable: false,
              render: this.getFilteredActions(data['actions'], 'recordActions').concat(this.getFilteredActions(data['actions'], 'dropdownActions'))
            });
          } else if (this.datatableService && this.datatableService.applicationType === 'workspace' && this.appData && !this.appData.hideActionColumn) {
            this.allData['columns'].push({
              prop: '_id',
              name: 'Actions',
              class: 'action-txt-align',
              sortable: false,
              render: this.getFilteredActions(data['actions'], 'recordActions').concat(this.getFilteredActions(data['actions'], 'dropdownActions'))
            });
          }
          this.allData['headerActions'] = this.getFilteredActions(data['actions'], 'headerActions') || [];
          this.allData['filters'] = data['filters'] || {};
          // show or hide filters....
          this.reopenFilters();
        }

        this.reInitColumnTotal();
        if (tt) {
          tt = tt.map((element, k) => {
            if (this.rowCalculations) {
            element = this.rowCalculateFun(element);
          }

          for (const i in element) {
            if (element.hasOwnProperty(i)) {
              if (this.cardVars[i] && this.cardVars[i][element[i]]) {
              this.cardVars[i][element[i]]['count'] += 1;
            }

            if (this.colCalculations[i] != null && this.colCalculations[i] !== undefined && element[i] &&
              parseFloat(this.colCalculations[i]) !== NaN && parseFloat(element[i]) !== NaN
            ) {
              this.colCalculations[i] = parseFloat(this.colCalculations[i]) + parseFloat(element[i]);
            }
              if (this.inlineEditCols[i]) {
                element[i] = this.inlineEditCols[i][element[i]];
              }
            }
          }
          return element;
        });
      }

      
      this.rows = [...tt];
      this.reInitColumnTotal();
      
      this.rows = [...tt];
      this.getSum();
      this._changeDetectorRef.detectChanges();
        }).catch(err => {
          this.helperService.openSnackBar(err);
          this.loadingIndicator = false;
          console.log(err);
        });
    } else {
      console.log('No regId');
    }
  }

  isArray(tt: any): boolean {
    return tt && typeof tt === 'object';
  }

  getFormatedDate(start, end) {
    start = start || new Date();
    end = end || new Date();
    return {
      $gte: `${moment(start).format('YYYY-MM-DD')} ${this.timeFilter.startTime}`,
      $lte: `${moment(end).format('YYYY-MM-DD')} ${this.timeFilter.endTime}`
    };
  }

  moveToInstanceList(url: string) {
    const tt = JSON.parse(localStorage.getItem('wsAppData')) || {};
    tt['processName'] = this.allData['integratedProcessName'];
    localStorage.setItem('wsAppData', JSON.stringify(tt));
    this.moveTo(url);
  }

  initDateFilter() {
    let startDate: any = new Date();
    const endDate = new Date();
    if (this.appData && this.appData.dataRangeTimeDiff) { 
      const timeParam = this.appData.dataRangeTimeDiff.substr(this.appData.dataRangeTimeDiff.length - 1, this.appData.dataRangeTimeDiff.length);
      const timeValue = this.appData.dataRangeTimeDiff.substr(0, this.appData.dataRangeTimeDiff.length - 1);
      startDate = moment().subtract(timeValue, timeParam);
      startDate = startDate.startOf('day');

    } else {
      startDate.setDate(startDate.getDate() - 7);
      startDate.setHours(0, 0, 0, 0);
    }
    endDate.setHours(23, 59, 59, 999);
    this.timeFilter['startDate'] = startDate;
    this.timeFilter['endDate'] = endDate;
    // this.timeFilter['startDate'] = `${moment(startDate).format("YYYY:MM:DD")} ${this.timeFilter.startTime}`;
    // this.timeFilter['endDate'] = `${moment(endDate).format("YYYY:MM:DD")} ${this.timeFilter.endTime}`;
  }

  reopenFilters() {
    if (this.dataTablePastRequestData && this.dataTablePastRequestData.openedFilters) {
      this.allData = this.allData || {};
      this.allData.filters = this.allData.filters || {};
      if (this.dataTablePastRequestData.openedFilters.advanceFilter !== null && this.dataTablePastRequestData.openedFilters.advanceFilter !== undefined) {
        this.allData.filters.noAdvanceFiltersSelected = this.dataTablePastRequestData.openedFilters.advanceFilter;
      }
      if (this.dataTablePastRequestData.openedFilters.dateRangeFilter !== null && this.dataTablePastRequestData.openedFilters.dateRangeFilter !== undefined) {
        this.allData.filters.hideDateRange = this.dataTablePastRequestData.openedFilters.dateRangeFilter;
      }
      if (this.dataTablePastRequestData.openedFilters.superFilter !== null && this.dataTablePastRequestData.openedFilters.superFilter !== undefined) {
        this.allData.showSuperFilter = this.dataTablePastRequestData.openedFilters.superFilter;
      }
    }
  }

  getRowClass(row) {
    return {
      'happ-summary': row.allSum
    };
  }

  rowCalculateFun(element) {
    for (const i in this.rowCalculations) {
      if (this.rowCalculations[i]['fields']) {
        element[i] = null;
        // tslint:disable-next-line:forin
        for (
          let j = 0;
          j < this.rowCalculations[i]['fields'].length;
          j++
        ) {
          const k = j + 1;
          if (
            !element[
            this.rowCalculations[i]['fields'][j]['operand']
            ] ||
            (element[
              this.rowCalculations[i]['fields'][j]['operand']
            ] &&
              parseFloat(
                element[
                this.rowCalculations[i]['fields'][j][
                'operand'
                ]
                ]
              ) === NaN)
          ) {
            element[
              this.rowCalculations[i]['fields'][j]['operand']
            ] = 0;
          } else {
            element[
              this.rowCalculations[i]['fields'][j]['operand']
            ] = parseFloat(
              element[
              this.rowCalculations[i]['fields'][j]['operand']
              ]
            );
          }
          switch (this.rowCalculations[i]['fields'][j]['operator']) {
            case '+':
              if (
                element[i] == null ||
                element[i] === undefined
              ) {
                element[i] =
                  element[
                  this.rowCalculations[i]['fields'][j][
                  'operand'
                  ]
                  ] +
                  (this.rowCalculations[i]['fields'][k] &&
                    element[
                    this.rowCalculations[i]['fields'][k][
                    'operand'
                    ]
                    ]
                    ? parseFloat(
                      element[
                      this.rowCalculations[i][
                      'fields'
                      ][k]['operand']
                      ]
                    )
                    : 0);
                j = j + 1;
              } else {
                element[i] +=
                  element[
                  this.rowCalculations[i]['fields'][j][
                  'operand'
                  ]
                  ];
              }

              break;
            case '-':
              if (
                element[i] == null ||
                element[i] === undefined
              ) {
                element[i] =
                  element[
                  this.rowCalculations[i]['fields'][j][
                  'operand'
                  ]
                  ] -
                  (this.rowCalculations[i]['fields'][k] &&
                    element[
                    this.rowCalculations[i]['fields'][k][
                    'operand'
                    ]
                    ]
                    ? parseFloat(
                      element[
                      this.rowCalculations[i][
                      'fields'
                      ][k]['operand']
                      ]
                    )
                    : 0);
                j = j + 1;
              } else {
                element[i] -=
                  element[
                  this.rowCalculations[i]['fields'][j][
                  'operand'
                  ]
                  ];
              }

              break;
            case '*':
              if (
                element[i] == null ||
                element[i] === undefined
              ) {
                element[i] =
                  element[
                  this.rowCalculations[i]['fields'][j][
                  'operand'
                  ]
                  ] *
                  (this.rowCalculations[i]['fields'][k] &&
                    element[
                    this.rowCalculations[i]['fields'][k][
                    'operand'
                    ]
                    ]
                    ? parseFloat(
                      element[
                      this.rowCalculations[i][
                      'fields'
                      ][k]['operand']
                      ]
                    )
                    : 1);
                j = j + 1;
              } else {
                element[i] *=
                  element[
                  this.rowCalculations[i]['fields'][j][
                  'operand'
                  ]
                  ];
              }
              break;
            case '/':
              if (
                element[i] == null ||
                element[i] === undefined
              ) {
                element[i] =
                  element[
                  this.rowCalculations[i]['fields'][j][
                  'operand'
                  ]
                  ] /
                  (this.rowCalculations[i]['fields'][k] &&
                    element[
                    this.rowCalculations[i]['fields'][k][
                    'operand'
                    ]
                    ]
                    ? parseFloat(
                      element[
                      this.rowCalculations[i][
                      'fields'
                      ][k]['operand']
                      ]
                    )
                    : 1);
                j = j + 1;
              } else {
                if (
                  element[
                  this.rowCalculations[i]['fields'][j][
                  'operand'
                  ]
                  ] !== 0
                ) {
                  element[i] /=
                    element[
                    this.rowCalculations[i]['fields'][
                    j
                    ]['operand']
                    ];
                }
              }
              break;
            case '%':
              if (
                element[i] == null ||
                element[i] === undefined
              ) {
                element[i] = element[this.rowCalculations[i]['fields'][j]['operand']] % (this.rowCalculations[i]['fields'][k] && element[ this.rowCalculations[i]['fields'][k]['operand']]
                    ? parseFloat(element[this.rowCalculations[i]['fields'][k]['operand']]) : 1);
                j = j + 1;
              } else {
                if (element[this.rowCalculations[i]['fields'][j]['operand']] !== 0) {
                  element[i] = element[i] * (element[this.rowCalculations[i]['fields'][j]['operand']] / 100);
                }
              }
              break;
            default:
          }
        }
        element[i] = element[i]
          ? parseFloat(element[i]).toFixed(2)
          : element[i];
      } else {
        element[i] = 0;
      }
    }
    return element;
  }

  ngAfterViewInit(): void {
    // this.formChartAndInlineEditVariable();
  }

  resetcolCalculationValues() {
    this.colCalculations = this.colCalculations || {};
    // tslint:disable-next-line:forin
    for (const i in this.colCalculations) {
      this.colCalculations[i] = 0;
    }
  }

  formChartAndInlineEditVariable() {
    this.allData = this.allData || {};
    this.allData['columns'] = this.allData['columns'] || [];
    this.allData['columns'].forEach(element => {
      if (element.cellTemplate) {
        this[element.cellTemplate]['render'] = element.render || [];
        element.cellTemplate = this[element.cellTemplate];
      }

      if (
        element['control_type'] &&
        element['control_type']['control_type'] === 'calculation'
      ) {
        this.rowCalculations[element['control_type']['label']] =
          element['control_type'];
      }

      if (
        element['control_type'] &&
        element['control_type']['inline_edit'] &&
        element['control_type']['category'] === 'radio'
      ) {
        if (element['control_type']['show_on_card']) {
          this.cardVarsArray.push({
            label: element['control_type']['label'],
            options: element['control_type']['options']
          });
          this.cardVars[element['control_type']['label']] = {};
          element['control_type']['options'].forEach(ele => {
            ele['count'] = 0;
            this.cardVars[element['control_type']['label']][
              ele.value || ele.title
            ] = ele;
          });
        }

        const options = {};
        element['control_type']['options'].forEach(ele => {
          options[ele.value || ele.title] = ele;
        });
        this.inlineEditCols[element['control_type']['label']] = options;
      }
    });
    setTimeout(() => {
      this.formatDataToChart();
    }, 500);
  }

  openScanqueueRecordsList() {
    this.router.navigate([`/offices/${this.officeId}/registries/scanqueuerecordslist/${this.allData['regId']}`
    ]);
  }

  moveTo(url) {
    if (url.includes('./') || url[0] === '/') {
      this.router.navigate([url], { relativeTo: this.route });
    } else {
      this.router.navigate([this.router.url + '/' + url]);
    }
  }

  navigateTo(url: string) {
    this.router.navigate([url]);
  }

  inlineEdit(row, key, bool, col) {
    if (col && col.control_type && col.control_type.inline_edit) {
      if (!row.allSum) {
        if (this.inlineEditCell) {
          for (const i in this.inlineEditCell) {
            if (this.inlineEditCell.hasOwnProperty(i)) {
              this.inlineEditCell[i] = false;
            }
          }
        }
        this.inlineEditCell[key] = bool;
      }
    }
  }

  validateNumber(e: any, value, control_type) {
    const current = value.value || '';
    const input = String.fromCharCode(e.charCode);
    const next = current + input;
    if (control_type && control_type.allow_decimal) {
      const reg = new RegExp(`^\\d*(?:[.,]\\d{0,${control_type.decimal_places}})?$`);
      // const reg = /^\d*(?:[.,]\d{0,})?$/;
      if (!reg.test(next)) {
        e.preventDefault();
      }
    }

    // if (next && ((parseFloat(next) < control_type.min || parseFloat(next) > control_type.max))) {
    //   e.preventDefault();
    // }
  }

  actionMoveTo(rowIndex, application, data, button, url) {
    if (application === 'deleteRecord') {
      this.helperService.openConfirmPopUp('popup.are_you_sure_you_want_to_delete_record')
      .subscribe((res) => {
        if (res) {
          this.helperService.deleteRequest(`api/reg/${this.allData['regId']}/${data['_id']}`)
          .then(() => {
            this.getServerSideRecord();
            this.datatableService.onPositionRecordChange.next(true);
            this.helperService.openSnackBar('Deleted Successfully');
          }).catch(err => {
            this.helperService.openSnackBar(err || 'Error in deleting record');
            console.log('Error in deleting record', err);
          });
          }
      });
    } else if (
      application === 'app.oneRecordView.edit.popup' ||
      application === 'app.oneRecordView.edit.sideMenu' ||
      application === 'app.oneRecordView.add.popup'
    ) {
      const recData = {};
      recData['regId'] = this.allData['regId'];
      recData['recId'] = data && data['_id'];
      recData['recData'] = data;
      recData['formFields'] = this.allData['columns'] || [];
      button.handler(recData);
    } else if (button.type === 'function') {
      const recData = {};

      data = data || {};
      this.updateReg(data._id, data._id, data._id, '_id', rowIndex, data)
      .then((tempData) => {
      recData['regId'] = this.allData['regId'];
      recData['recId'] = data['_id'];
      recData['childId'] = this.route.snapshot.params['childId'];
      recData['parentId'] = this.route.snapshot.params['parentId'];
      // tslint:disable-next-line:max-line-length
      this.helperService.getRequest(`api/registries/${recData['regId']}/registries-record/${recData['recId']}/replicate-record-register/${recData['childId']}?parentId=${recData['parentId']}`)
        .then(() => {
          this.snackBar.open('Saved', 'Okay', {
            duration: 2000
          });
        })
        .catch(err => {
          console.log(err);
          this.snackBar.open(err || 'Error Occured', 'Okay', {
            duration: 2000
          });
        });
      button.handler(recData);
      }).catch(err => {
        console.log(err);
      });
    } else if (url) {
      if (data) {
        url = url.replace(':recId', data['_id']);
      }
      this.moveTo(url);
    } else if (application === 'app.message.start') {
      this.performAction(button, data);
    } else {
      if (button['placement']['headerActions']) {
        this.actionHandler(button);
      } else {
        this.actionClick(application, data, button);
      }
    }
  }

  actionClick(application, data, button) {
    if (button.type === 'function') {
      const recData = {};
      recData['regId'] = this.allData['regId'];
      recData['recId'] = data['_id'];
      recData['childId'] = this.route.snapshot.params['childId'];
      recData['parentId'] = this.route.snapshot.params['parentId'];
      // tslint:disable-next-line:max-line-length
      this.helperService
        .getRequest(
          `api/registries/${recData['regId']}/registries-record/${
          recData['recId']
          }/replicate-record-register/${
          recData['childId']
          }?parentId=${recData['parentId']}`
        )
        .then(() => {
          this.snackBar.open('Saved', 'Okay', {
            duration: 2000
          });
        })
        .catch(err => {
          console.log(err);
          this.snackBar.open(err || 'Error Occured', 'Okay', {
            duration: 2000
          });
        });
      button.handler(recData);
    } else if (application === 'app.customregistries.openChildRegister') {
      this.allData['openChildRegister'](button.params, data);
    } else if (application === 'app.persona24') {
      this.allData['openPersonaEdit'](data['_id']);
    } else {
      this.datatableService['editClickHandle'](this.allData, data);
    }
  }

  reset() {
    this.resetFilterValues();
    this.getServerSideRecord();
  }
  resetFilterValues() {
    this.dateTimeFilterType = (this.appData && this.appData.defaultDateFilter) || '##df_all##';
    this.valueFilter = {
      'registredDataTime': this.getDateFromDateSearchControlerType()
    };
    this.initDateFilter();
    this.resetValues();
    this.resetcolCalculationValues();
  }

  filterIconClicked() {
    this.resetValues();
    this.resetcolCalculationValues();
    this.allData.filters.noAdvanceFiltersSelected = !this.allData.filters.noAdvanceFiltersSelected;
    this.dateRangeFilter();
    this.fastQuery = '';
  }

  resetValues() {
    this.processFilters = {};
    this.filters = {};
    this.searchText = '';
    this.allData = this.allData || {};
    this.allData.filters = this.allData.filters || {};
  }

  search() {
    this.page.pageNumber = 0;
    if (this.requestData && this.requestData.page) {
      this.requestData.page.pageNumber = 0;
    }
    this.getFilters();
    this.resetcolCalculationValues();
    this.getServerSideRecord();
  }

  excel() {
    this.getFilters();
    const excelUrl = `${environment.serverUrl}api/registries/${
      this.allData['regId']
      }/reports/xlsx/v2?filter=${JSON.stringify(this.requestData.filters)}`;
    this.reportGenrate('xlsx', excelUrl);
  }

  pdf() {
    this.getFilters();
    const pdfUrl = `${environment.serverUrl}api/registries/${
      this.allData['regId']
      }/reports/pdf/v2?filter=${JSON.stringify(this.requestData.filters)}`;
    this.reportGenrate('pdf', pdfUrl);
  }

  reportGenrate(type, url) {
    const bodydata = {
      columns: this.allData.columns,
      defaultRegisterDateTimeSort: this.allData
        .defaultRegisterDateTimeSort,
      filterRecord: {},
      filters: this.requestData.filters,
      officeId: this.allData.officeId,
      page: this.allData.page,
      regId: this.allData.regId,
      search: {
        value: this.fastQuery || '',
        regex: false
      },
      sort: this.allData.sort
    };

    if (this.requestData['currentMQFilter'] && this.appData && this.appData['hardFilter']) {
      this.requestData['mqFilter'] = `${this.appData['hardFilter']} AND ${this.requestData['currentMQFilter']}`;
      // delete this.requestData['currentMQFilter'];
    } else if (this.requestData['currentMQFilter']) {
      this.requestData['mqFilter'] = this.requestData['currentMQFilter'];
      // delete this.requestData['currentMQFilter'];
    } else if (this.appData && this.appData['hardFilter']) {
      this.requestData['mqFilter'] = this.appData['hardFilter'];
    }

    bodydata['mqFilter'] = this.requestData['mqFilter'] || '';

    const win = window.open('_blank');
    const doc = win.document;
    doc.open('text/html');
    doc.write(
      `<html><head><title>Report Generate</title></head>
            <body style="display: flex;flex-direction: column;justify-content: center;align-items: center;text-align: center;min-height: 100vh;background-color: #f7f7f7;">
            <div><h3>Report Generate<h3/><br/><br/> <img src="https://rigp.pinbox24.com/assets/images/Processing.gif"/></div>
            <body></html>`
    );
    const a = document.createElement('a');
    document.body.appendChild(a);
    this.downloadFile(url, bodydata, function (blob) {
      doc.close();
      const urlBlob = URL.createObjectURL(blob);
      a.href = urlBlob;
      a.download =
        new Date().toISOString().slice(0, 10) + '_Report.' + type;
      a.click();
      win.close();
    });
  }

  downloadFile(url, body, success) {
    const xhr = new XMLHttpRequest();
    xhr.open('POST', url, true);
    const credentials =
      JSON.parse(localStorage.getItem('ngStorage-token')) || {};
    xhr.setRequestHeader('Authorization', credentials.token || '');
    xhr.setRequestHeader('officeId', this.allData.officeId || '');
    xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
    xhr.send(JSON.stringify(body));
    xhr.responseType = 'blob';
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        if (success) {
          success(xhr.response);
        }
      }
    };
    xhr.send(null);
  }

  filter(query, fastSearchWithField = false) {
    if (fastSearchWithField) {
      this.valueFilter = {};
      this.valueFilter[this.fastSearchField] = this.fastQuery2;
      return this.search();
    }
    this.page.pageNumber = 0;
    if (this.requestData && this.requestData.page) {
      this.requestData.page.pageNumber = 0;
    }
    this.searchText = query;
    this.resetcolCalculationValues();
    this.getServerSideRecord();
  }

  dateRangeFilter() {
    this.allData.filters.hideDateRange = !this.allData.filters.hideDateRange;
    if (!this.allData.filters.noAdvanceFiltersSelected) {
      this.allData.filters.hideDateRange = false;
    }
    if (this.allData.filters.hideDateRange) {
      const startDate = new Date();
      const endDate = new Date();
      startDate.setDate(startDate.getDate() - 7);
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(23, 59, 59, 999);
      this.allData.filters['startDate'] = startDate;
      this.allData.filters['endDate'] = endDate;
    }
  }

  formatDataToChart() {
    this.chartData = [];
    this.cardVarsArray.forEach(ele => {
      this.chartData[this.chartData.length] = [];
      ele.options.forEach(ele2 => {
        this.chartData[this.chartData.length - 1].push({
          name: ele2.value || ele2.title,
          value: this.cardVars[ele.label][ele2.value || ele2.title]
            .count
        });
      });
    });
  }

  getFilters() {
    if (this.datatableService && this.datatableService.instanceFilters && Object.keys(this.datatableService.instanceFilters)) {
      this.requestData['filterRecord'] = this.datatableService.instanceFilters;
    } else {
      this.requestData['filterRecord'] = {};
    }

    if ((this.allData.filters && this.allData.filters.noAdvanceFiltersSelected ) || this.allData.showSuperFilter || this.allData.fastSearchWithField) {
      this.valueFilter = this.valueFilter || {};
      if (this.allData && this.allData.filters && this.allData.filters.hideDateRange && this.dateTimeFilterType === 'customValue') {
        // this.valueFilter['registredDataTime'] = this.getFormatedDate(this.timeFilter.startDate, this.timeFilter.endDate);
        this.requestData['filters'] = Object.assign(this.valueFilter, { 'registredDataTime': this.getFormatedDate(this.timeFilter.startDate, this.timeFilter.endDate) });
      } else {
        this.valueFilter['registredDataTime'] = this.getDateFromDateSearchControlerType();
        this.requestData['filters'] = this.valueFilter;
      }
    } else {
      this.requestData['filters'] = {};
    }

    for (const i in this.requestData['filters']) {
      if (!this.requestData['filters'][i]) {
        delete this.requestData['filters'][i];
      }
    }

    this.filters = this.requestData['filters'];
  }

  testing(data) {
  }

  async updateReg(recId, value, prevVal, key, rowIndex, allValue) {
    try {

      
      if (!this.allData['regId']) {
        this.snackBar.open('ERROR: Register Id not found', 'Okay', {
          duration: 2000
        });
        return;
      }

      
      allValue[key] = value;
      allValue = this.calculationOnSave(allValue);
      
      const tt = JSON.parse(JSON.stringify(allValue));
      delete tt['_id'];
      console.log(tt);

      const data = {};
      this.processFilters = {};
      data[key] = value;
      await this.helperService.updateRegisterRecord(this.allData['regId'], recId, tt);
      if (this.allData['refreshOnEdit']) {
        this.getServerSideRecord();
      } else {
        this.getSum();
        this.datatableService.onPositionRecordChange.next(true);
        if (this.cardVars[key]) {
          this.cardVars[key][value].count += 1;
          if (
            this.cardVars[key][prevVal.value || prevVal.title]
          ) {
            this.cardVars[key][
              prevVal.value || prevVal.title
            ].count -= 1;
          }
          this.formatDataToChart();
        }

        if (this.inlineEditCols[key]) {
          this.rows[rowIndex][key] = this.inlineEditCols[key][
            value
          ];
        } else {
          this.rows[rowIndex][key] = value;
        }
        this.rowCalculateFun(this.rows[rowIndex]);
        if (
          this.colCalculations &&
          Object.keys(this.colCalculations).length > 0
        ) {
          for (const i in this.colCalculations) {
            if (i !== 'allSum') {
              this.colCalculations[i] = 0;
            }
          }
          this.rows.forEach((element, k) => {
            if (!element['allSum']) {
              for (const i in element) {
                if (
                  this.colCalculations[i] != null &&
                  this.colCalculations[i] !== undefined &&
                  element[i] &&
                  parseFloat(this.colCalculations[i]) !==
                  NaN &&
                  parseFloat(element[i]) !== NaN
                ) {
                  this.colCalculations[i] =
                    parseFloat(
                      this.colCalculations[i]
                    ) + parseFloat(element[i]);
                }
              }
            }
          });
          this.summaryArray = [];
          if (this.allData && this.allData.application === 'position' ) {
            this.allData.positionParentUpdate(this.colCalculations);
          }
          // format
          this.colCalculations = this.colCalculations || {};
          for (const i in this.colCalculations) {
            if (i !== 'allSum') {
              this.colCalculations[i] =
                this.colCalculations[i] &&
                this.colCalculations[i].toFixed(2);
            }
          }
          this.summaryArray.push(this.colCalculations);
        }
        this.rows = [...this.rows];
      }
      this.updateParent();
      return true;
      } catch (err) {
        console.log(err);
      }
  }

  updateParent() {
    if (
      JSON.parse(localStorage.getItem('ngStorage-selectedOffice')) &&
      JSON.parse(localStorage.getItem('ngStorage-selectedOffice'))[
      'apps'
      ] &&
      this.allData['extra'] &&
      this.allData['extra']['GDPR-RES-ID']
    ) {
      const GDPR_Resource = JSON.parse(
        localStorage.getItem('ngStorage-selectedOffice')
      )['apps']['gdpr-resources']['id'];
      const count = {
        conclusion1:
          this.cardVars['GDPR-Q-CON']['Zgodność']['count'] || 0,
        conclusion2:
          this.cardVars['GDPR-Q-CON']['Do usprawnienia']['count'] ||
          0,
        conclusion3:
          this.cardVars['GDPR-Q-CON']['Potencjalne ryzyko'][
          'count'
          ] || 0,
        conclusion4:
          this.cardVars['GDPR-Q-CON']['Niezgodny']['count'] || 0
      };
      this.helperService
        .updateRegisterRecord(
          GDPR_Resource,
          this.allData['extra']['GDPR-RES-ID'],
          count
        )
        .then(data => { })
        .catch(err => {
          console.log(err);
          this.snackBar.open(
            err || 'Error occured while updating data',
            'Okay',
            {
              duration: 2000
            }
          );
        });
    }
  }

  actionHandler(type) {
    if (type.application === 'app.customregistries.openChildRegister') {
      this.allData['openChildRegister'](type);
    } else {
      this.datatableService['AddClickHandle'](this.allData);
    }
  }

  openWSAppsSettings(tabIndex) {
    tabIndex = tabIndex || 0;
    const dialogRef = this.dialog.open(WsAppsSettingsComponent, {
      width: '100%',
      height: '100%',
      panelClass: 'happ-form-builder-dialog',
      data: {
        appData: this.appData,
        wsInfo: this.wsInfo,
        processRoles: this.appData.processRoles,
        requiredDataFields: this.appData.requiredDataFields,
        gvRequiredFields: this.appData.gvRequiredFields,
        tabIndex
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.appData = result;
        this.checkWSRequiredField();
      }
    });
  }
  

  openBulActionPopup(action?) {
    let isTask = false;
    let taskObject = {};
    if (action && action.application === 'app.message.start') {
      isTask = true;
      taskObject = action.taskInfo.task;
    }
    
    const dialogRef = this.dialog.open(RecordBulkUpdateComponent, {
      width: '600px',
      height: 'max-content',
      panelClass: 'happ-form-builder-dialog',
      data: {
        isTask: isTask,
        taskObject: taskObject,
        regId: this.allData.regId, 
        regName: this.allData.regName,
        columnFields: this.allData.columns,
        dtTableFilter: (this.requestData),
        mqHardFilter: (this.allData && this.allData.mqHardFilterString),
        recCount: (this.page && this.page.totalElements) || 0
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getServerSideRecord();
      }
    });
  }

  openDescriptionPopup(control_type, value) {
    const dialogRef = this.dialog.open(DescriptionPopupComponent, {
      width: control_type && control_type.fullWidth ? '100%' : '60%',
      height: control_type && control_type.fullWidth ? '100%' : '60%',
      panelClass: 'happ-form-builder-dialog',
      restoreFocus: false,
      data: { type: 'html', value: (value || (control_type && control_type.data)) }
    });
  }

  openInstructionPopup(data) {
    const dialogRef = this.dialog.open(DescriptionPopupComponent, {
      width: '60%',
      height: '60%',
      restoreFocus: false,
      panelClass: 'happ-form-builder-dialog',
      data: { type: 'data', value: data }
    });
  }

  savePrivateFilter() {
    this.confirmDialogRef = this.dialog.open(InputDialogComponent, {
      disableClose: false
    });

    this.confirmDialogRef.componentInstance.inputPlaceholder =
      'Nazwa filtru';
    this.confirmDialogRef.componentInstance.confirmMessage =
      'Utwórz nowy filtr';
    this.confirmDialogRef.componentInstance.inputValue = '';

    this.confirmDialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.privateFilter.addPrivateFilter(
          this.dataTablesParameters['filters'],
          result,
          this.allData.regId
        );
      }
      this.confirmDialogRef = null;
    });
  }

  triggerPrivateFilter(eve) {
    this.filters = eve || {};
    this.getServerSideRecord();
  }

  superFilter(filterOption, buttonInfo, empty) {
    this.valueFilter[filterOption['label']] = this.valueFilter[filterOption['label']] || {};

    if (this.valueFilter && this.valueFilter[filterOption['label']] && filterOption['label']) {
      const tt = (buttonInfo.value || buttonInfo.title);
      this.valueFilter[filterOption['label']].$in = this.valueFilter[filterOption['label']].$in || [];

      // for empty filter
      if (empty && this.valueFilter && this.valueFilter[filterOption['label']] && this.valueFilter[filterOption['label']].$in && 
      !this.valueFilter[filterOption['label']].$in.includes(null)) {
        this.valueFilter[filterOption['label']].$in.push(null);
        this.valueFilter[filterOption['label']].$in.push(undefined);
        this.valueFilter[filterOption['label']].$in.push(0);
        this.valueFilter[filterOption['label']].$in.push('');
      } else if (empty && this.valueFilter && this.valueFilter[filterOption['label']] && this.valueFilter[filterOption['label']].$in) {
        let index = this.valueFilter[filterOption['label']].$in.indexOf(null);
        if (index >= 0) {
          this.valueFilter[filterOption['label']].$in.splice(index, 1);
        } 
        index = this.valueFilter[filterOption['label']].$in.indexOf(undefined);
        if (index >= 0) {
          this.valueFilter[filterOption['label']].$in.splice(index, 1);
        } 
        index = this.valueFilter[filterOption['label']].$in.indexOf(0);
        if (index >= 0) {
          this.valueFilter[filterOption['label']].$in.splice(index, 1);
        } 
        index = this.valueFilter[filterOption['label']].$in.indexOf('');
        if (index >= 0) {
          this.valueFilter[filterOption['label']].$in.splice(index, 1);
        } 

        if (this.valueFilter[filterOption['label']].$in && this.valueFilter[filterOption['label']].$in.length === 0) {
          delete this.valueFilter[filterOption['label']];
        }
      }


      if (this.valueFilter && this.valueFilter[filterOption['label']] && this.valueFilter[filterOption['label']].$in && 
          !this.valueFilter[filterOption['label']].$in.includes(tt)) {
            this.valueFilter[filterOption['label']].$in.push(tt);
      } else if (this.valueFilter && this.valueFilter[filterOption['label']] && this.valueFilter[filterOption['label']].$in) {
        const index = this.valueFilter[filterOption['label']].$in.indexOf(tt);
        if (index >= 0) {
          this.valueFilter[filterOption['label']].$in.splice(index, 1);
          if (this.valueFilter[filterOption['label']].$in && this.valueFilter[filterOption['label']].$in.length === 0) {
            delete this.valueFilter[filterOption['label']];
          }
        } 
      }
      // this.getServerSideRecord();
    }
  }

  
  isInt(n){
    return Number(n) === n && n % 1 === 0;
  }

  isFloat(n){
    return Number(n) === n && n % 1 !== 0;
  }

  updateParentRecord() {
    this.getSums(true, this.requestData)
    .then((data) => {
      this.summaryArray = this.summaryArray || [];
      this.summaryArray[0] = this.summaryArray[0] || {};
      data = (data && data[0]) || {};
      delete data['_id'];
      // tslint:disable-next-line:forin
      for (const i in data) {
        if (data[i] && this.isFloat(data[i])) {
          this.summaryArray[0][i] = data[i];
        } else if (data[i]) {
          this.summaryArray[0][i] = parseFloat(parseFloat(data[i]).toFixed(2));
        }
      }
      this.summaryArray = [...this.summaryArray];
      console.log(data);

      this.helperService.updateRegisterRecord(this.datatableService.params['regId'], this.datatableService.params['recId'], data)
      .then(() => {
        this.datatableService.onRecordUpdated.next(data);
      }).catch(err => {
        console.log(err);
      });
    }).catch(err => {
      console.log(err);
    });
  }

  getSum() {
    if (this.allData && this.allData.summingColumns && this.allData.summingColumns.length) {
      this.getSums(false, this.requestData)
      .then((data) => {
        this.summaryArray = this.summaryArray || [];
        this.summaryArray[0] = this.summaryArray[0] || {};
        data = (data && data[0]) || {};
        delete data['_id'];
        // tslint:disable-next-line:forin
        for (const i in data) {
          if (data[i] && this.isFloat(data[i])) {
            this.summaryArray[0][i] = parseFloat(parseFloat(data[i]).toFixed(2));
          } else if (data[i]) {
            this.summaryArray[0][i] = data[i];
          }
        }
        this.summaryArray = [...this.summaryArray];

      }).catch(err => {
        console.log(err);
    });
  }
}
  
  
  getSums(isPosition: boolean, requestData: any) {
    if (isPosition) {
      delete requestData['filter'];
      delete requestData['mqFilter'];
    }
    requestData['columns'] = this.allData.summingColumns || [];
    return this.helperService.postRequest(`api/registries/sum/${this.regId}`, requestData);
  }

  downloadPdf(docId) {
    this.helperService
      .getDocument(docId)
      .then(docData => {
        if (docData) {
          this.helperService.downloadDocument(docData);
        } else {
          this.snackBar.open('Data is null', 'Okay', {
            duration: 2000
          });
        }
      })
      .catch(err => {
        this.snackBar.open(err || 'Some error Occured', 'Okay', {
          duration: 2000
        });
      });
  }

  saveFilterToOffice() {
    this.helperService.openInputPopUp('Filter Name', 'You are about to save current filter in office document', '')
    .subscribe((data) => {
      if (data) {
        this._officeHelper.getLocalOfficeData()
          .then((officeData: IOfficeData) => {
            const officeFilters = officeData.officeFilters || [];
            const tempFilter = {
              name: data,
              regId: this.regId,
              regName: this.allData['regName']
            };
            if (this.requestData) {
              if (this.requestData.filterRecord && Object.keys(this.requestData.filterRecord).length) {
                tempFilter['filter'] = this.requestData.filterRecord;
              }
              if (this.requestData.filters && Object.keys(this.requestData.filters).length) {
                if (tempFilter['filter']) {
                  // tslint:disable-next-line:forin
                  for (const i in this.requestData.filters) {
                    tempFilter['filter'][i] = this.requestData.filters[i];
                  }
                } else {
                  tempFilter['filter'] = this.requestData.filters;
                }
              }

              if (tempFilter['filter'] && Object.keys(tempFilter['filter']).length) {
                tempFilter['filter'] = JSON.stringify(tempFilter['filter']); 
              }

              if (this.requestData.mqFilter) {
                tempFilter['mqFilter'] = this.requestData.mqFilter;
              }
            }

            officeFilters.push(tempFilter);
            this._officeHelper.updateOfficeDoc({officeFilters})
            .then(() => {
              this._officeHelper.refreshLocalOfficeData();
            }).catch(err => {
              this._officeHelper.refreshLocalOfficeData();
              console.log(err);
            });
          }).catch(err => {
            console.log(err);
          });
      }
    });
  }

  calculationOnSave(data) {
    let tt = this.helperService.getXTypeVariables((this.allData.ng5Form && this.allData.ng5Form['ng5Form']), 'calculation_on_save') || [];
    tt = this.helperService.transformSort(tt, 'calculationSort') || [];
    tt.forEach(ele => {
      let sum = 0;
      if (ele['fields']) {
        sum += this.helperService.rowCalculateOnSave(ele, data);
      }
      data[ele['label']] = sum;
      // this is to save title too..
      if (ele['saveRange']) {
        ele['range'] = ele['range'] || [];
        ele['range'].forEach((range) => {
          if (sum >= range.min && sum <= range.max) {
            data[ele['rangeLabel']] = range.title || sum;
          }
        });
      }
    });
    return data;
  }

  getColumnSummary(ele) {
    console.log(ele);
    return `--`;
  }

  getOfficeFiltersForRegister() {
    this._officeHelper.getOfficeFilters()
    .then((filters) => {
      this.officeFilters = filters || [];
      this.officeFilters = this.officeFilters.filter(ele => (ele && ele.regId === this.regId));
    }).catch(err => {
      console.log(err);
    });
  }

  officeFilterClicked(filter) {
    if (filter) {
      if (filter.filter) {
        const tt = JSON.parse(filter.filter);
        this.requestData.filters = this.requestData.filters || {};
        // tslint:disable-next-line:forin
        for (const i in tt) {
          this.requestData.filters[i] = tt[i];
        }
      }
      this.getServerSideRecord(null, filter.mqFilter);
    }
  }

  performAction(action, data) {
    if (action && action.application === 'app.message.start') {
      this.helperService.postRequest(`api/registries/execute_task/${this.regId}/${data._id}`, {taskObject: action.taskInfo.task})
      .then((data) => {
        this.helperService.openSnackBar('Task Executed');
        this.getServerSideRecord();
      }).catch(err => {
        console.log(err);
      });
    }
  }

  moveToProcessSettings(processId) {
    this.router.navigate([`/offices/${this.officeId}/process-settings/process-settings-list/process-settings-list/${processId}`]);
  }
}
